import React, { useState } from 'react';
import { Confirm, useTranslate } from 'react-admin';
import { useFormState } from 'react-final-form';
import SaveButtonEx from '../_extensions/react-admin/ra-ui-materialui/src/button/SaveButtonEx';
import { useTerminalsContext } from '../../contexts/TerminalsProvider';
import { Dialog, DialogTitle, DialogActions, Button, } from '@material-ui/core';
import { OrderService, OrderStatus } from '../../entities/';
import { useArrivedPopupContext } from 'resources/orders/forms/ArrivedPopupContextManager';
import { isInArray } from 'utils/general';

const getWarningsIfExist = (values, initialValues, warningValidations, terminals) => {
    const warnings = [];
    for (const [key, validator] of Object.entries(warningValidations)) {      
        const warningMsg = validator(values, initialValues, terminals);
        if (warningMsg) warnings.push(warningMsg);
    }
    return warnings ? warnings : null;
};

const translateWarnings = (warnings, translate) => {
    return warnings.map(warning => translate(warning));
};

export const SaveForceTruckArrivedForOrder = ({ warningValidations, ...props }) => {
    const translate = useTranslate();
    const { open } = useArrivedPopupContext()
    const { values, initialValues, errors } = useFormState();
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [warningsInfo, setWarningsInfo] = useState('');
    const [handleSubmitProps, setHandleSubmitProps] = useState();
    const [showFormDialog, setShowFormDialog] = useState(false);
    const { data: terminals } = useTerminalsContext();
    const [ customClickProp, setCustomClickProp ] = useState();
    const [ saveProps, setSaveProps] = useState();
    const forceSetVehicleArrivalCondition = (isInArray([OrderService.reloadCarTerminalCar, OrderService.crossDock], values["service"]) && values['status'] == OrderStatus.LOADING_READY) || 
                                            (values['service'] == OrderService.reloadCarCar && (values['status'] == OrderStatus.LOADING_READY || values['status'] == OrderStatus.ONE_IN_TERMINAL)) || 
                                            (values['service'] == OrderService.intoPlukkStorage && values['status'] == OrderStatus.LOADING_READY )

    const handleConfirmSave = () => {
		setConfirmOpen(false);
        setCustomClickProp(handleSubmitProps);
	};

    const handleConfirmClose = () => {
        setConfirmOpen(false);
    };

    const saveDialog = () => {
        let prefix = null;
        if (!values['is_eta_arrived']){
            prefix = "eta";
        }
        else if(!values['is_etd_arrived']){
            prefix = "etd";
        }
        if (prefix){
            open(prefix);  
        }
        setShowFormDialog(false);
    };
    
    const closeDialog = () => {
        setShowFormDialog(false);
        showWarnings(saveProps);
    }

    const handleSubmitWithWarnings = (onSaveProps) => {
        setSaveProps(onSaveProps);

        if ((!values['is_eta_arrived'] || !values['is_etd_arrived']) && forceSetVehicleArrivalCondition){
            setShowFormDialog(true);
        }
        else{
            setShowFormDialog(false)
            showWarnings(onSaveProps);
        }
    }

    const showWarnings = (onSaveProps) => {
        if (Object.keys(errors).length){
            setCustomClickProp(onSaveProps);
            return;
        }
        const warningsContent = getWarningsIfExist(values, initialValues, warningValidations, terminals);
        
        if (warningsContent && warningsContent.length) {            
            setWarningsInfo(translateWarnings(warningsContent, translate).join('\n'));
            setHandleSubmitProps(onSaveProps);
            setConfirmOpen(true);
        } else {
            setCustomClickProp(onSaveProps);
        }
    }


    return (
        <>
            <SaveButtonEx {...props} customHandleClick={handleSubmitWithWarnings} customClickProp={customClickProp}/>

            <Confirm
                isOpen={confirmOpen}
                content={warningsInfo}
                title="osfc.dialogs.order_warnings.title"
                confirm="osfc.dialogs.order_warnings.actions.confirm"
                cancel="osfc.dialogs.order_warnings.actions.cancel"
                onConfirm={handleConfirmSave}
                onClose={handleConfirmClose}
            />

            <Dialog open={showFormDialog} onClose={() => setShowFormDialog(false)}>
                <DialogTitle>{translate('resources.orders.messages.warn.set-car-arrived')}</DialogTitle>
                <DialogActions>
                    <Button onClick={saveDialog} variant="contained" color="primary">
                    {translate('resources.orders.buttons.set-car-arrived-button')}
                    </Button>

                    <Button onClick={closeDialog} variant="contained" color="secondary">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
